"use client"

import {
  Stack,
  Box,
  Text,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Flex,
  Input,
  FormLabel,
  Select,
  Button,
  Spinner,
} from "@chakra-ui/react"
import "services/Recruit/assets/css/CreateJobOpening/style.css"
import { ArrowBackIcon } from "@chakra-ui/icons"
import { globalStyles } from "common/theme/styles"
import { Field, Formik, Form } from "formik"
import CustomDatePicker from "common/components/datePicker/CustomDatePicker"
import { useEffect, useState, useMemo, useCallback } from "react"
import TextEditor from "common/components/textEditor/TextEditor"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { constant } from "common/constant"
import { interviewTabsData } from "services/Recruit/data/tabsData"
import ActionNavbar from "common/components/actionBar/ActionNavbar"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { getApi } from "common/services/api"
import { API_PATHS } from "common/services/apiPaths"
import { interviewRoundOptions } from "services/Recruit/data/dropdownData"
import { interviewValidationSchema } from "services/Recruit/schema/interviewSchema"
import ReactSelect from "react-select"
import { recruitConstant } from "services/Recruit/constant"
import { jobTitleOptions } from "services/Recruit/data/dropdownData"
import { interviewModeOptions } from "services/Recruit/data/dropdownData"
import { fetchUserData } from "common/redux/reducers/userSlice"
import { INTERVIEW_INITIAL_VALUES } from "common/initialValues/formInitialValues"
import { interviewStatusOptions } from "services/Recruit/data/dropdownData"
import { updateInterview } from "common/redux/reducers/interviewSlice"
import { postInterview } from "common/redux/reducers/interviewSlice"
import { getDepartments } from "common/redux/reducers/departmentSlice"
import * as Yup from "yup"
import { HasAccess } from "common/utils/accessUtils"
import { getLoggedInUser, getEffectiveRoleName, isEmployee as checkIsEmployee } from "common/utils/roleUtils"
import { accessModuleTitles } from "common/constant"
import Interview from "../interview"
import InfoModal from "common/components/infoModel"
import { isEasingArray } from "framer-motion"


const OverviewPanel = (
  {
    navigate,
    isOverviewMode,
    id,
    applicationData,
    departments,
    permission,
    colors,
    activeTabIndex,
    getTabStates,
    handleTabChange,
    handleNext,
    handleBack,
    dispatch,
    setSelectedJob,
    getInitialValues,
    transformInterviewDataForAPI,
    fetchApplicationById,
    panelData,
    combineDateAndTime,
    createLoading,
    updateLoading,
    isEmployee,
    getRoundOptionsForApplication,
    fetchScheduledRoundsForApplication,
    normalizeRoundValue,
    currentInterviewRound,
    isRoundOptionsLoading,
  }
) => {
  return (
    <>
      <Box className="createJobOpening-container">
        <Box className="createJobOpening-mainContainer">
          <Box className="createJobOpening-breadCrumb">
            <ArrowBackIcon onClick={() => navigate("/recruitment/interviews")} fontSize="20px" cursor={"pointer"} />
            <Text className="createJobOpening-pageTitle">
              {isOverviewMode ? "Overview" : id ? constant.editInterview : constant.createInterview}
            </Text>
          </Box>
        </Box>

        <Formik
          enableReinitialize={true}
          initialValues={getInitialValues()}
          validationSchema={interviewValidationSchema}
          onSubmit={(values, { resetForm }) => {
            console.log("interview values", values)
            const transformedValues = transformInterviewDataForAPI(values)

            if (id) {
              dispatch(
                updateInterview({
                  id,
                  values: transformedValues,
                  navigate,
                }),
              )
            } else {
              dispatch(
                postInterview({
                  values: transformedValues,
                  resetForm,
                  navigate,
                }),
              )
            }
          }}
        >
          {({ values, setFieldValue, handleSubmit, errors, dirty, isValid, setErrors, setTouched }) => {
            // Calculate tab states for current form state
            const tabStates = getTabStates(values, dirty, isValid, activeTabIndex)

            return (
              <Form onSubmit={handleSubmit}>
                <Tabs
                  index={activeTabIndex}
                  onChange={(index) =>
                    handleTabChange(
                      index,
                      values,
                      dirty,
                      isValid
                    )
                  }
                  className="createJobOpening-tabsContainer"
                  variant="unstyled"
                  orientation="vertical"
                >
                  {/* tab list  */}
                  <TabList
                    w={"40%"}
                    className="createJobOpening-tabListContainer"
                  >
                    {interviewTabsData.map(
                      ({ label, Icon }, index) => {
                        const tabState = tabStates[index];
                        const isCurrentTab =
                          index === activeTabIndex;

                        return (
                          <Tab
                            className="createJobOpening-tabs"
                            key={index}
                            _selected={{
                              color: colors.cta["100"],
                              borderLeft: "2px solid",
                              borderColor:
                                colors.cta["100"],
                            }}
                            _hover={{
                              color: tabState.isAccessible
                                ? colors.cta["100"]
                                : "inherit",
                              cursor: tabState.isAccessible
                                ? "pointer"
                                : "not-allowed",
                            }}
                            _focus={{ boxShadow: "none" }}
                            display="flex"
                            alignItems="center"
                            gap="8px"
                            opacity={
                              tabState.isAccessible
                                ? 1
                                : 0.6
                            }
                            cursor={
                              tabState.isAccessible
                                ? "pointer"
                                : "not-allowed"
                            }
                            isDisabled={
                              !tabState.isAccessible
                            }
                          >
                            <Icon size={20} />
                            {label}
                            {tabState.isValid && (
                                <Text
                                  fontSize="xs"
                                  color="green.500"
                                >
                                  ✓
                                </Text>
                              )}
                          </Tab>
                        );
                      }
                    )}
                  </TabList>

                  {/* tab panels */}
                  <TabPanels
                    w={"60%"}
                    className="createJobOpening-tabsPanelContainer"
                  >
                    {/* job opening tab */}
                    <TabPanel className="createJobOpening-tabsPanel">
                      <Box className="createJobOpening-tabsPanelBody">
                        <Flex gap={"20px"}>
                          <Box w={"50%"}>
                            <FormLabel htmlFor="application">
                              {constant.application}
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="application">
                              {({ field, meta, form }) => {
                                const postingTitleOptions =
                                  applicationData &&
                                    applicationData.length > 0
                                    ? applicationData
                                      .filter(
                                        (option) =>
                                          option?.job && 
                                          option?.job?.deleted !== true &&
                                          option?.candidateDetails?.deleted !== true
                                      )
                                      .map((option) => {
                                        let formattedTitle = option?.job?.postingTitle || "";
                                        
                                        // Handle custom titles that start with "Other-"
                                        if (formattedTitle.startsWith("Other-")) {
                                          // Remove "Other-" prefix and use the custom title as-is
                                          formattedTitle = formattedTitle.replace("Other-", "");
                                        } else {
                                          // Format standard titles: split by hyphen, capitalize, and join with space
                                          formattedTitle = formattedTitle
                                            .split("-")
                                            .map(
                                              (word) =>
                                                word
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                word.slice(1)
                                            )
                                            .join(" ");
                                        }
                                        
                                        const jobId = option.customId;
                                        const candidateName = option?.candidateDetails?.name || "";  
                                        return {
                                          value: option?._id,
                                          label: `${formattedTitle} - ${candidateName} (${jobId})`,
                                          id: option?._id,
                                        };
                                      })
                                    : [
                                      {
                                        value: "",
                                        label:
                                          "No data found",
                                        isDisabled: true,
                                      },
                                    ];

                                // Find selected option by matching the _id
                                const selectedOption =
                                  (postingTitleOptions &&
                                    postingTitleOptions.length >
                                    0 &&
                                    postingTitleOptions.find(
                                      (option) =>
                                        option?.value ===
                                        field?.value
                                    )) ||
                                  null;

                                return (
                                  <>
                                    <ReactSelect
                                      isDisabled={
                                        !permission?.update ||
                                        isOverviewMode ||
                                        isEmployee
                                      }
                                      name={field.name}
                                      value={selectedOption}
                                      onBlur={() =>
                                        form.setFieldTouched(
                                          field.name,
                                          true
                                        )
                                      }
                                      menuPortalTarget={
                                        document.body
                                      }
                                      menuPosition="fixed"
                                      options={
                                        postingTitleOptions
                                      }
                                      className="basic-single-select reactSelect"
                                      classNamePrefix="select"
                                      onChange={async (
                                        selectedOption
                                      ) => {
                                        const selectedId =
                                          selectedOption
                                            ? selectedOption?.value
                                            : "";
                                        form.setFieldValue(
                                          field.name,
                                          selectedId
                                        );

                                        const scheduledRounds =
                                          await fetchScheduledRoundsForApplication(selectedId);

                                        const selectedJob =
                                          applicationData.find(
                                            (job) =>
                                              job?._id ===
                                              selectedId
                                          );
                                        setSelectedJob(
                                          selectedJob || {}
                                        );

                                        if (selectedId) {
                                          const applicationDetails =
                                            await fetchApplicationById(
                                              selectedId
                                            );
                                          if (
                                            applicationDetails
                                          ) {
                                            if (
                                              applicationDetails
                                                .candidateDetails
                                                ?.name
                                            ) {
                                              form.setFieldValue(
                                                "candidate",
                                                applicationDetails
                                                  .candidateDetails
                                                  .name
                                              );
                                            }

                                            if (
                                              applicationDetails
                                                .candidateDetails
                                                ?.email
                                            ) {
                                              form.setFieldValue(
                                                "candidateEmail",
                                                applicationDetails
                                                  .candidateDetails
                                                  .email
                                              );
                                            }

                                            if (
                                              applicationDetails
                                                .candidateDetails
                                                ?.phone
                                            ) {
                                              form.setFieldValue(
                                                "candidatePhoneNo",
                                                applicationDetails
                                                  .candidateDetails
                                                  .phone
                                              );
                                            }

                                            if (
                                              applicationDetails
                                                .job
                                                ?.postingTitle
                                            ) {
                                              const postingTitle =
                                                applicationDetails
                                                  .job
                                                  .postingTitle;
                                              form.setFieldValue(
                                                "jobTitle",
                                                postingTitle
                                              );
                                            }

                                            if (
                                              applicationDetails
                                                .job
                                                ?.department &&
                                              departments?.length >
                                              0
                                            ) {
                                              departments.forEach((dept, index) => {
                                                console.log(`   Department ${index}:`, {
                                                  _id: dept._id,
                                                  name: dept.name,
                                                  type: typeof dept._id
                                                });
                                              });
                                              const matchingDepartment =
                                                departments.find(
                                                  (dept) =>
                                                    dept._id ===
                                                    applicationDetails
                                                      .job
                                                      .department._id
                                                );
                                              if (
                                                matchingDepartment
                                              ) {
                                                form.setFieldValue(
                                                  "department",
                                                  matchingDepartment._id
                                                );
                                              }
                                            }
                                          }
                                        } else {
                                          form.setFieldValue(
                                            "candidate",
                                            ""
                                          );
                                          form.setFieldValue(
                                            "candidateEmail",
                                            ""
                                          );
                                          form.setFieldValue(
                                            "candidatePhoneNo",
                                            ""
                                          );
                                          form.setFieldValue(
                                            "jobTitle",
                                            ""
                                          );
                                          form.setFieldValue(
                                            "department",
                                            ""
                                          );
                                        }

                                        const isSelectedRoundUnavailable =
                                          form.values.round &&
                                          scheduledRounds.some(
                                            (round) =>
                                              normalizeRoundValue(round) ===
                                              normalizeRoundValue(form.values.round)
                                          ) &&
                                          !(id && normalizeRoundValue(currentInterviewRound) === normalizeRoundValue(form.values.round))

                                        if (isSelectedRoundUnavailable) {
                                          form.setFieldValue("round", "");
                                        }
                                      }}
                                      placeholder="Select Job Title"
                                      isClearable
                                      isSearchable
                                      styles={{
                                        control: (
                                          provided
                                        ) => ({
                                          ...provided,
                                          borderColor:
                                            meta.touched &&
                                              meta.error
                                              ? colors.errorText
                                              : colors.borderColor,
                                        }),
                                      }}
                                    />
                                    {meta.touched &&
                                      meta.error && (
                                        <Text
                                          color={
                                            colors.errorText
                                          }
                                        >
                                          {meta.error}
                                        </Text>
                                      )}
                                  </>
                                );
                              }}
                            </Field>
                          </Box>

                          <Box w={"50%"}>
                            <FormLabel htmlFor="candidate">
                              {constant.candidate}
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="candidate">
                              {({ field, meta }) => (
                                <>
                                  <Input
                                    disabled
                                    {...field}
                                    placeholder={
                                      constant.candidate
                                    }
                                    borderColor={
                                      meta.touched &&
                                        meta.error
                                        ? colors.errorText
                                        : colors.borderColor
                                    }
                                  />
                                  {meta.touched &&
                                    meta.error && (
                                      <Text
                                        color={
                                          colors.errorText
                                        }
                                      >
                                        {meta.error}
                                      </Text>
                                    )}
                                </>
                              )}
                            </Field>
                          </Box>
                        </Flex>

                        <Flex gap={"20px"}>
                          <Box w={"50%"}>
                            <FormLabel htmlFor="candidateEmail">
                              {constant.candidateEmail}
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="candidateEmail">
                              {({ field, meta }) => (
                                <>
                                  <Input
                                    disabled
                                    {...field}
                                    placeholder={
                                      constant.candidateEmail
                                    }
                                    borderColor={
                                      meta.touched &&
                                        meta.error
                                        ? colors.errorText
                                        : colors.borderColor
                                    }
                                  />
                                  {meta.touched &&
                                    meta.error && (
                                      <Text
                                        color={
                                          colors.errorText
                                        }
                                      >
                                        {meta.error}
                                      </Text>
                                    )}
                                </>
                              )}
                            </Field>
                          </Box>

                          <Box w={"50%"}>
                            <FormLabel htmlFor="candidatePhoneNo">
                              {constant.candidatePhoneNo}
                            </FormLabel>
                            <Field name="candidatePhoneNo">
                              {({ field, meta }) => (
                                <>
                                  <Input
                                    disabled
                                    {...field}
                                    type="number"
                                    placeholder={
                                      constant.candidatePhoneNo
                                    }
                                    borderColor={
                                      meta.touched &&
                                        meta.error
                                        ? colors.errorText
                                        : colors.borderColor
                                    }
                                  />
                                  {meta.touched &&
                                    meta.error && (
                                      <div>
                                        {meta.error}
                                      </div>
                                    )}
                                </>
                              )}
                            </Field>
                          </Box>
                        </Flex>

                        <Flex gap={"20px"}>
                          <Box w={"50%"}>
                            <FormLabel htmlFor="jobTitle">
                              {constant.postingTitle}
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="jobTitle">
                              {({ field, meta, form }) => {
                                // Check if the job title is a custom one (starts with "Other-")
                                let selectedOption;
                                if (field.value && field.value.startsWith("Other-")) {
                                  // Create a custom option for display
                                  const customTitle = field.value.replace("Other-", "");
                                  selectedOption = {
                                    value: field.value,
                                    label: customTitle
                                  };
                                } else {
                                  // Use standard lookup
                                  selectedOption = jobTitleOptions.find(
                                    (option) => option.value === field.value
                                  ) || null;
                                }

                                return (
                                  <>
                                    <ReactSelect
                                      isDisabled={true}
                                      name={field.name}
                                      value={selectedOption}
                                      onBlur={() =>
                                        form.setFieldTouched(
                                          field.name,
                                          true
                                        )
                                      }
                                      menuPortalTarget={
                                        document.body
                                      }
                                      menuPosition="fixed"
                                      options={
                                        jobTitleOptions
                                      }
                                      className="basic-single-select reactSelect"
                                      classNamePrefix="select"
                                      onChange={(
                                        selectedOption
                                      ) => {
                                        const selectedValue =
                                          selectedOption
                                            ? selectedOption.value
                                            : "";
                                        form.setFieldValue(
                                          field.name,
                                          selectedValue
                                        );
                                      }}
                                      placeholder="Select Job Title"
                                      isClearable
                                      isSearchable
                                      styles={{
                                        control: (
                                          provided
                                        ) => ({
                                          ...provided,
                                          borderColor:
                                            meta.touched &&
                                              meta.error
                                              ? colors.errorText
                                              : colors.borderColor,
                                        }),
                                      }}
                                    />
                                    {meta.touched &&
                                      meta.error && (
                                        <Text
                                          color={
                                            colors.errorText
                                          }
                                        >
                                          {meta.error}
                                        </Text>
                                      )}
                                  </>
                                );
                              }}
                            </Field>
                          </Box>

                          <Box w={"50%"}>
                            <FormLabel htmlFor="department">
                              {constant.departmentName}
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="department">
                              {({ field, meta }) => {
                                return (
                                  <>
                                    <Select
                                      disabled
                                      {...field}
                                      value={
                                        field.value || ""
                                      }
                                      borderColor={
                                        meta.touched &&
                                          meta.error
                                          ? colors.errorText
                                          : colors.borderColor
                                      }
                                    >
                                      <option
                                        value=""
                                        hidden
                                      >
                                        {
                                          constant.selectDepartment
                                        }
                                      </option>
                                      {departments?.length >
                                        0 &&
                                        departments.map(
                                          (option) => (
                                            <option
                                              key={
                                                option._id
                                              }
                                              value={
                                                option._id
                                              }
                                            >
                                              {option.name}
                                            </option>
                                          )
                                        )}
                                    </Select>
                                    {meta.touched &&
                                      meta.error && (
                                        <Text
                                          color={
                                            colors.errorText
                                          }
                                        >
                                          {meta.error}
                                        </Text>
                                      )}
                                  </>
                                );
                              }}
                            </Field>
                          </Box>
                        </Flex>



                        <Flex gap={"20px"}>
                          <Box w={"50%"}>
                            <FormLabel htmlFor="interviewers">
                              Panel
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="interviewers">
                              {({ field, meta, form }) => {
                                const interviewerOptions =
                                  panelData?.length > 0
                                    ? panelData.map(
                                      (panel) => ({
                                        value: panel._id, // Use panel ID as value
                                        label:
                                          panel?.panelName?.firstName +
                                          " " +
                                          panel?.panelName?.lastName, // Show panel member's name
                                      })
                                    )
                                    : [];

                                // Ensure field value is an array
                                const fieldValue =
                                  Array.isArray(field.value)
                                    ? field.value
                                    : field.value
                                      ? [field.value]
                                      : [];

                                // Find selected options based on field value (panel IDs)
                                const selectedOptions =
                                  interviewerOptions.filter(
                                    (option) =>
                                      fieldValue.includes(
                                        option.value
                                      )
                                  );

                                return (
                                  <>
                                    <ReactSelect
                                      isDisabled={
                                        !permission?.update ||
                                        isOverviewMode
                                      }
                                      isMulti
                                      name={field.name}
                                      value={
                                        selectedOptions
                                      }
                                      onBlur={() =>
                                        form.setFieldTouched(
                                          field.name,
                                          true
                                        )
                                      }
                                      menuPortalTarget={
                                        document.body
                                      }
                                      menuPosition="fixed"
                                      options={
                                        interviewerOptions
                                      }
                                      className="basic-multi-select reactSelect"
                                      classNamePrefix="select"
                                      onChange={(
                                        selectedOptions
                                      ) => {
                                        const selectedValues =
                                          selectedOptions
                                            ? selectedOptions.map(
                                              (option) =>
                                                option.value
                                            )
                                            : [];
                                        form.setFieldValue(
                                          field.name,
                                          selectedValues
                                        );
                                      }}
                                      placeholder={
                                        "Select Panel"
                                      }
                                      isClearable
                                      isSearchable
                                      styles={{
                                        control: (
                                          provided
                                        ) => ({
                                          ...provided,
                                          borderColor:
                                            meta.touched &&
                                              meta.error
                                              ? colors.errorText
                                              : colors.borderColor,
                                        }),
                                      }}
                                    />
                                    {meta.touched &&
                                      meta.error && (
                                        <Text
                                          color={
                                            colors.errorText
                                          }
                                        >
                                          {meta.error}
                                        </Text>
                                      )}
                                  </>
                                );
                              }}
                            </Field>
                          </Box>

                          <Box w={"50%"}>
                            <FormLabel htmlFor="interviewMode">
                              {constant.interviewMode}
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="interviewMode">
                              {({ field, meta }) => (
                                <>
                                  <Select
                                    isDisabled={
                                      !permission?.update ||
                                      isOverviewMode
                                    }
                                    {...field}
                                    value={
                                      field.value || ""
                                    }
                                    borderColor={
                                      meta.touched &&
                                        meta.error
                                        ? colors.errorText
                                        : colors.borderColor
                                    }
                                  >
                                    <option value="" hidden>
                                      {
                                        constant.selectInterviewType
                                      }
                                    </option>
                                    {interviewModeOptions.map(
                                      (
                                        {
                                          value,
                                          label,
                                          disabled,
                                          hidden,
                                        },
                                        index
                                      ) => (
                                        <option
                                          key={index}
                                          value={label}
                                          disabled={
                                            disabled
                                          }
                                          hidden={hidden}
                                        >
                                          {constant[
                                            label
                                          ] || label}
                                        </option>
                                      )
                                    )}
                                  </Select>
                                  {meta.touched &&
                                    meta.error && (
                                      <Text
                                        color={
                                          colors.errorText
                                        }
                                      >
                                        {meta.error}
                                      </Text>
                                    )}
                                </>
                              )}
                            </Field>
                          </Box>
                        </Flex>

                        <Flex gap={"20px"}>
                          <Box w={"50%"}>
                            <FormLabel htmlFor="round">
                              {constant.interviewRound}
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="round">
                              {({ field, meta, form }) => {
                                const roundOptions = getRoundOptionsForApplication(form.values.application)
                                const isCurrentValueDisabled =
                                  field.value &&
                                  roundOptions.some(
                                    (option) =>
                                      option.value === field.value && option.disabled
                                  ) &&
                                  !(id && normalizeRoundValue(currentInterviewRound) === normalizeRoundValue(field.value))

                                return (
                                  <>
                                  <Select
                                    isDisabled={
                                      !permission?.update ||
                                      isOverviewMode ||
                                      isRoundOptionsLoading
                                    }
                                    {...field}
                                    value={
                                      field.value || ""
                                    }
                                    borderColor={
                                      meta.touched &&
                                        meta.error
                                        ? colors.errorText
                                        : colors.borderColor
                                    }
                                  >
                                    <option value="" hidden>
                                      {constant.selectRound}
                                    </option>
                                    {roundOptions.map(
                                      (
                                        {
                                          value,
                                          label,
                                          disabled,
                                          hidden,
                                        },
                                        index
                                      ) => (
                                        <option
                                          key={index}
                                          value={value}
                                          disabled={
                                            disabled
                                          }
                                          hidden={hidden}
                                        >
                                          {constant[
                                            label
                                          ] || label}
                                        </option>
                                      )
                                      )}
                                  </Select>
                                  {!isOverviewMode && isCurrentValueDisabled && (
                                    <Text color={colors.errorText}>
                                      This round already has an interview scheduled for the selected application.
                                    </Text>
                                  )}
                                  {!isOverviewMode && isRoundOptionsLoading && (
                                    <Text color="gray.500">
                                      Loading available rounds...
                                    </Text>
                                  )}
                                  {!isOverviewMode && !isRoundOptionsLoading && roundOptions.length > 0 && roundOptions.every((option) => option.disabled) && (
                                    <Text color="gray.500">
                                      All interview rounds are already scheduled for this application.
                                    </Text>
                                  )}
                                  {meta.touched &&
                                    meta.error && (
                                      <Text
                                        color={
                                          colors.errorText
                                        }
                                        >
                                          {meta.error}
                                        </Text>
                                      )}
                                  </>
                                )
                              }}
                            </Field>
                          </Box>

                          <Box w={"50%"}>
                            <FormLabel htmlFor="interviewDate">
                              {constant.interviewDate}
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="interviewDate">
                              {({ field, form, meta }) => (
                                <>
                                  <CustomDatePicker
                                    isDisabled={!permission?.update || isOverviewMode}
                                    minDate={new Date()}
                                    fullWidth={true}
                                    startDate={field.value}
                                    setStartDate={(date) => {
                                      form.setFieldValue(field.name, date)
                                      form.setFieldValue("startTime", null)
                                      form.setFieldValue("endTime", null)
                                    }}
                                  />
                                  {meta.touched && meta.error && (
                                    <Text color={colors.errorText}>{meta.error}</Text>
                                  )}
                                </>
                              )}
                            </Field>
                          </Box>

                        </Flex>

                        <Flex gap={"20px"}>
                          <Box w={"50%"}>
                            <FormLabel htmlFor="startTime">
                              {constant.startTime}
                            </FormLabel>
                            <Field name="startTime">
                              {({ field, meta, form }) => {
                                const interviewDate = form.values.interviewDate
                                const isDateSelected = !!interviewDate
                                const isToday = interviewDate &&
                                  new Date(interviewDate).toDateString() === new Date().toDateString()

                                // Calculate minimum time for today
                                const minTime = isToday ? new Date() : undefined
                                // Set maxTime to end of day
                                const maxTime = isToday ? new Date(new Date().setHours(23, 59, 59, 999)) : undefined

                                return (
                                  <>
                                    <CustomDatePicker
                                      isDisabled={
                                        !isDateSelected ||
                                        !permission?.update ||
                                        isOverviewMode
                                      }
                                      time={true}
                                      fullWidth={true}
                                      minTime={minTime}
                                      maxTime={maxTime}
                                      startDate={field.value}
                                      setStartDate={(date) => {
                                        if (!interviewDate) return

                                        const nextValue = combineDateAndTime(
                                          new Date(interviewDate),
                                          new Date(date)
                                        )
                                        form.setFieldValue(field.name, nextValue)

                                        // Clear end time if it exists and is before or equal to new start time
                                        const currentEndTime = form.values.endTime
                                        if (currentEndTime && new Date(currentEndTime) <= new Date(nextValue)) {
                                          form.setFieldValue("endTime", null)
                                        }
                                      }}
                                    />
                                    {meta.touched && meta.error && (
                                      <Text color={colors.errorText}>{meta.error}</Text>
                                    )}
                                    {!isDateSelected && (
                                      <Text fontSize="xs" color={colors.errorText} mt={1}>
                                        Please select interview date first
                                      </Text>
                                    )}
                                  </>
                                )
                              }}
                            </Field>
                          </Box>
                          <Box w={"50%"}>
                            <FormLabel htmlFor="endTime">
                              {constant.endTime}
                            </FormLabel>
                            <Field name="endTime">
                              {({ field, form, meta }) => {
                                const interviewDate = form.values.interviewDate
                                const startTime = form.values.startTime
                                const isDateSelected = !!interviewDate
                                const isStartTimeSelected = !!startTime
                                const isToday = interviewDate &&
                                  new Date(interviewDate).toDateString() === new Date().toDateString()

                                // Calculate minimum time
                                let minTime = undefined
                                if (isStartTimeSelected) {
                                  // End time must be after start time - add 1 minute
                                  const startTimeDate = new Date(startTime)
                                  minTime = new Date(startTimeDate.getTime() + 60000) // Add 1 minute in milliseconds
                                } else if (isToday) {
                                  minTime = new Date()
                                }

                                // Set maxTime to end of day
                                const maxTime = new Date(new Date().setHours(23, 59, 59, 999))

                                return (
                                  <>
                                    <CustomDatePicker
                                      isDisabled={
                                        !isDateSelected ||
                                        !isStartTimeSelected ||
                                        !permission?.update ||
                                        isOverviewMode
                                      }
                                      time={true}
                                      fullWidth={true}
                                      minTime={minTime}
                                      maxTime={maxTime}
                                      startDate={field.value}
                                      setStartDate={(date) => {
                                        if (!interviewDate) return

                                        const nextValue = combineDateAndTime(
                                          new Date(interviewDate),
                                          new Date(date)
                                        )
                                        form.setFieldValue(field.name, nextValue)
                                      }}
                                    />
                                    {meta.touched && meta.error && (
                                      <Text color={colors.errorText}>{meta.error}</Text>
                                    )}
                                    {!isDateSelected && (
                                      <Text fontSize="xs" color={colors.errorText} mt={1}>
                                        Please select interview date first
                                      </Text>
                                    )}
                                    {isDateSelected && !isStartTimeSelected && (
                                      <Text fontSize="xs" color={colors.errorText} mt={1}>
                                        Please select start time first
                                      </Text>
                                    )}
                                  </>
                                )
                              }}
                            </Field>
                          </Box>
                        </Flex>
                        <Flex gap={"20px"}>
                          <Box w={"50%"}>
                            <FormLabel htmlFor="interviewStatus">
                              {
                                constant.interviewStatusLabel
                              }
                              <span className="astrick">
                                *
                              </span>
                            </FormLabel>
                            <Field name="interviewStatus">
                              {({ field, meta, form }) => {
                                // const initialStatus = form.initialValues.interviewStatus;
                                // const optionsToShow = id
                                //   ? interviewStatusOptions.filter(
                                //     ({ value }) => value === initialStatus || value === "cancelled",
                                //   )
                                //   : interviewStatusOptions
                                const optionsToShow = interviewStatusOptions;
                                return (
                                  <>
                                    <Select
                                      isDisabled={
                                        !permission?.update ||
                                        isOverviewMode
                                      }
                                      {...field}
                                      value={
                                        field.value || ""
                                      }
                                      onChange={(e) => {
                                        const newStatus = e.target.value;
                                        form.setFieldValue(field.name, newStatus);

                                        // Clear reason field when status is NOT cancelled
                                        if (newStatus !== 'cancelled') {
                                          form.setFieldValue('reason', '');
                                        }
                                      }}
                                      borderColor={
                                        meta.touched &&
                                          meta.error
                                          ? colors.errorText
                                          : colors.borderColor
                                      }
                                    >
                                      <option value="" hidden>
                                        {
                                          constant.selectInterviewStatus
                                        }
                                      </option>
                                      {optionsToShow.map(
                                        (
                                          {
                                            value,
                                            label,
                                            disabled,
                                            hidden,
                                          },
                                          index
                                        ) => (
                                          <option
                                            key={index}
                                            value={value}
                                            disabled={
                                              disabled
                                            }
                                            hidden={hidden}
                                          >
                                            {constant[
                                              label
                                            ] || label}
                                          </option>
                                        )
                                      )}
                                    </Select>
                                    {meta.touched &&
                                      meta.error && (
                                        <Text
                                          color={
                                            colors.errorText
                                          }
                                        >
                                          {meta.error}
                                        </Text>
                                      )}
                                  </>
                                )
                              }}
                            </Field>
                          </Box>
                          {values.interviewStatus === 'cancelled' &&
                            <Box w={"50%"}>
                              <FormLabel htmlFor="reason">
                                {recruitConstant.reason}
                                <span className="astrick">*</span>
                              </FormLabel>
                              <Field name="reason">
                                {({ field, meta, form }) => (
                                  <>
                                    <Input
                                      isDisabled={
                                        !permission?.update ||
                                        isOverviewMode
                                      }
                                      {...field}
                                      placeholder={recruitConstant.reasonPlaceholder}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (val.startsWith(' ')) return
                                        form.setFieldValue('reason', val);
                                      }}
                                      borderColor={
                                        meta.touched && meta.error
                                          ? colors.errorText
                                          : colors.borderColor
                                      }
                                    />
                                    {meta.touched && meta.error && (
                                      <Text color={colors.errorText}>{meta.error}</Text>
                                    )}
                                  </>
                                )}
                              </Field>
                            </Box>}
                        </Flex>
                      </Box>
                      <Box className="createJobOpening-tabsPanelFooter">
                        <Button
                          className="theme-btn2 cancelBtn"
                          sx={{
                            textTransform: "capitalize",
                          }}
                          variant="outline"
                          colorScheme={colors.error["100"]}
                          size="sm"
                          onClick={() =>
                            navigate("/recruitment/interviews")
                          }
                        >
                          {constant.cancel}
                        </Button>
                        <Button
                          disabled={
                            !tabStates[activeTabIndex]
                              ?.canProceed
                          }
                          className="nextBtn"
                          variant="primary"
                          onClick={() =>
                            handleNext(
                              values,
                              dirty,
                              isValid,
                              setErrors,
                              setTouched
                            )
                          }
                        >
                          {constant.next}
                        </Button>
                      </Box>
                    </TabPanel>

                    {/* Description information */}
                    <TabPanel className="createJobOpening-tabsPanel">
                      <Box className="createJobOpening-tabsPanelBody">
                        <Box w={"100%"}>
                          <Text className="textEditorHeading">
                            {constant.commentForInterviewer}
                          </Text>
                          <Field name="commentForInterviewer">
                            {({ field, meta }) => (
                              <>
                                <TextEditor
                                  isDisabled={
                                    !permission?.update ||
                                    isOverviewMode
                                  }
                                  toolbarId="commentForInterviewer"
                                  value={field.value || ""}
                                  handleChange={(
                                    content
                                  ) => {
                                    const cleanedValue =
                                      content ===
                                        "<p><br></p>"
                                        ? ""
                                        : content;
                                    field.onChange?.({
                                      target: {
                                        name: "commentForInterviewer",
                                        value: cleanedValue,
                                      },
                                    });
                                  }}
                                  handleBlur={() =>
                                    field.onBlur?.({
                                      target: {
                                        name: "commentForInterviewer",
                                      },
                                    })
                                  }
                                  borderColor={
                                    meta.touched &&
                                      meta.error
                                      ? colors.errorText
                                      : colors.borderColor
                                  }
                                  errorMsg={
                                    meta.touched &&
                                      meta.error
                                      ? meta.error
                                      : ""
                                  }
                                />
                                {meta.touched &&
                                  meta.error && (
                                    <Text
                                      color={
                                        colors.errorText
                                      }
                                    >
                                      {meta.error}
                                    </Text>
                                  )}
                              </>
                            )}
                          </Field>
                        </Box>

                        {/* <Box w={"100%"}>
                                                            <Text className="textEditorHeading">{constant.interviewerFeedback}</Text>
                                                            <Field name="interviewerFeedback">
                                                                {({ field, meta }) => (
                                                                    <>
                                                                        <TextEditor
                                                                            isDisabled={!permission?.update}
                                                                            toolbarId="interviewerFeedback"
                                                                            value={field.value || ""}
                                                                            handleChange={(content) => {
                                                                                const cleanedValue = content === "<p><br></p>" ? "" : content
                                                                                field.onChange?.({
                                                                                    target: { name: "interviewerFeedback", value: cleanedValue },
                                                                                })
                                                                            }}
                                                                            handleBlur={() => field.onBlur?.({ target: { name: "interviewerFeedback" } })}
                                                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                            errorMsg={meta.touched && meta.error ? meta.error : ""}
                                                                        />
                                                                        {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                    </>
                                                                )}
                                                            </Field>
                                                        </Box> */}
                      </Box>

                      <Box className="createJobOpening-tabsPanelFooter">
                        <Button
                          onClick={handleBack}
                          className="backBtn"
                        >
                          {constant.back}
                        </Button>
                        {!isOverviewMode && (
                          <Button
                            disabled={
                              createLoading ||
                              updateLoading ||
                              !dirty || // disable if form hasn't changed in create mode
                              !isValid || // disable if there are any validation errors
                              !permission?.update
                            }
                            className="nextBtn"
                            variant="primary"
                            type="submit"
                          >
                            {createLoading ||
                              updateLoading ? (
                              <Spinner size="sm" />
                            ) : id ? (
                              constant.update
                            ) : (
                              constant.save
                            )}
                          </Button>
                        )}
                        {isOverviewMode && (
                          <Button
                            onClick={() =>
                              navigate("/recruitment/interviews")
                            }
                            className="nextBtn"
                            variant="primary"
                            type="button"
                          >
                            Return to Interviews
                          </Button>
                        )}
                      </Box>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </>
  )
}


const CreateInterview = () => {
  const normalizeRoundValue = useCallback((roundValue) => String(roundValue || "").trim().toLowerCase(), [])
  const loggedInUser = getLoggedInUser();
  const effectiveRoleName = getEffectiveRoleName(loggedInUser);
  const isEmployee = checkIsEmployee(loggedInUser);
  const colors = globalStyles.colors
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [highestTabReached, setHighestTabReached] = useState(0)
  const { id } = useParams()

  const [applicationData, setApplicationData] = useState(null)
  const [selectedJob, setSelectedJob] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [isRoundOptionsLoading, setIsRoundOptionsLoading] = useState(false)
  const [scheduledRoundsByApplication, setScheduledRoundsByApplication] = useState({})
  const { users } = useSelector((state) => state.users)
  const [interviewData, setInterviewData] = useState(null)
  const { departments } = useSelector((state) => state.departments)
  const [permission] = HasAccess([accessModuleTitles.Interviews]);
  const [isOverviewMode, setIsOverviewMode] = useState(false)
  const location = useLocation();
  const { mode } = location.state || {};
  const dateFromCalendar = location.state?.date;

  const [activeMainTab, setActiveMainTab] = useState(0);

  const handleMainTabChange = (index) => {
    setActiveMainTab(index);
  };



  useEffect(() => {
    const mode = sessionStorage.getItem("mode");

    if (mode === "overview") {
      setIsOverviewMode(true);
    } else {
      setIsOverviewMode(false);
    }
  }, []);

  // Define validation schemas for each tab
  const tabValidationSchemas = useMemo(
    () => ({
      0: Yup.object().shape({
        application: Yup.string().required("Application is required"),
        candidate: Yup.string().required("Candidate is required"),
        candidateEmail: Yup.string()
          .email("Invalid candidate email")
          .required("Candidate email is required"),
        interviewers: Yup.array()
          .of(Yup.string().required("Each panel ID is required"))
          .min(1, "At least one interviewer panel is required")
          .required("Interviewers are required"),
        round: Yup.string().required("Interview round is required"),
        interviewStatus: Yup.string().required("Interview status is required"),
        interviewMode: Yup.string().required("Interview mode is required"),
        interviewDate: Yup.date().required("Interview date is required").typeError("Invalid interview date"),
        startTime: Yup.date()
          .transform((value, originalValue) => (originalValue === "" ? null : value))
          .nullable()
          .typeError("Invalid start time"),
        endTime: Yup.date()
          .transform((value, originalValue) => (originalValue === "" ? null : value))
          .nullable()
          .typeError("Invalid end time")
          .when("startTime", (startTime, schema) =>
            startTime ? schema.min(Yup.ref("startTime"), "End time must be after start time") : schema
          ),
        reason: Yup.string()
          .when("interviewStatus", {
            is: "cancelled",
            then: (schema) =>
              schema
                .required("Reason is required when interview is cancelled")
                .min(10, "Reason must be at least 10 characters long")
                .max(250, "Reason must be less than 250 characters"),
            otherwise: (schema) => schema.nullable(),
          }),
      }),
      1: Yup.object().shape({
        interviewerFeedback: Yup.string().nullable(),
        commentForInterviewer: Yup.string().nullable(),
      }),
    }),
    [],
  )

  // Function to check if a specific tab is valid
  const isTabValid = useCallback(
    (values, tabIndex) => {
      try {
        tabValidationSchemas[tabIndex].validateSync(values, { abortEarly: false })
        return true
      } catch (error) {
        return false
      }
    },
    [tabValidationSchemas],
  )
  // Function to get tab navigation states
  const getTabStates = useCallback(
    (values, dirty, isValid, currentTabIndex) => {
      const tabStates = {}

      // Find the first invalid tab among visited tabs
      let firstInvalidTab = null
      for (let i = 0; i <= highestTabReached; i++) {
        if (!isTabValid(values, i)) {
          firstInvalidTab = i
          break
        }
      }

      for (let i = 0; i <= 1; i++) {
        if (i < currentTabIndex) {
          // Previous tabs are always accessible
          tabStates[i] = { isAccessible: true, isValid: isTabValid(values, i) }
        } else if (i === currentTabIndex) {
          // Current tab - always accessible
          const currentTabValid = isTabValid(values, i)

          tabStates[i] = {
            isAccessible: true,
            isValid: currentTabValid,
            canProceed: currentTabValid,
          }
        } else if (i <= highestTabReached && (firstInvalidTab === null || i <= firstInvalidTab)) {
          // Previously visited tabs - accessible only if no invalid tabs before them
          tabStates[i] = { isAccessible: true, isValid: isTabValid(values, i), canProceed: false }
        } else {
          // Future tabs or tabs after first invalid tab - not accessible
          tabStates[i] = { isAccessible: false, isValid: false, canProceed: false }
        }
      }

      return tabStates
    },
    [isTabValid, highestTabReached],
  )

  const handleTabChange = useCallback(
    (index, values, dirty, isValid) => {
      // Allow going back to previous tabs without validation
      if (index < activeTabIndex) {
        setActiveTabIndex(index)
        return
      }

      // If trying to stay on the same tab, allow it
      if (index === activeTabIndex) {
        return
      }

      // Check if navigation is allowed based on tab states
      const tabStates = getTabStates(values, dirty, isValid, activeTabIndex)

      if (tabStates[index]?.isAccessible) {
        setActiveTabIndex(index)
      } else {
        toast.error("Please complete the current step before proceeding")
      }
    },
    [activeTabIndex, getTabStates],
  )

  const handleNext = useCallback(
    (values, dirty, isValid, setErrors, setTouched) => {
      if (activeTabIndex < 1) {
        const currentTabValid = isTabValid(values, activeTabIndex)

        if (currentTabValid) {
          const newTabIndex = activeTabIndex + 1
          setActiveTabIndex(newTabIndex)
          setHighestTabReached(Math.max(highestTabReached, newTabIndex))
        } else {
          // Validate current tab to show errors
          try {
            tabValidationSchemas[activeTabIndex].validateSync(values, { abortEarly: false })
          } catch (error) {
            const errors = {}
            const touchedFields = {}
            error.inner.forEach((err) => {
              errors[err.path] = err.message
              touchedFields[err.path] = true
            })
            setErrors(errors)
            setTouched(touchedFields)
          }
          toast.error("Please fill all required fields before proceeding")
        }
      }
    },
    [activeTabIndex, isTabValid, tabValidationSchemas, highestTabReached],
  )

  const handleBack = useCallback(() => {
    if (activeTabIndex > 0) {
      setActiveTabIndex(activeTabIndex - 1)
    }
  }, [activeTabIndex])

  // Set highest tab reached for edit mode
  useEffect(() => {
    if (id && interviewData) {
      setHighestTabReached(1) // In edit mode, allow access to all tabs
    }
  }, [id, interviewData])

  const fetchApplications = async () => {
    setIsLoading(true)
    try {
      const result = await getApi("api/recruitment/application/?allData=true")
      if (result?.data?.data) {
        setApplicationData(result?.data?.data)
      }
    } catch (e) {
      toast.error(recruitConstant.errorMsg)
      console.error("Error fetching job openings:", e)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchApplicationById = async (applicationId) => {
    try {
      const result = await getApi(`api/recruitment/application/${applicationId}`)
      if (result?.data?.application) {
        return result.data?.application
      }
    } catch (e) {
      toast.error(recruitConstant.errorMsg)
      console.error("Error fetching application details:", e)
    }
    return null
  }

  const fetchScheduledRoundsForApplication = useCallback(
    async (applicationId) => {
      if (!applicationId) {
        return []
      }

      setIsRoundOptionsLoading(true)

      try {
        const result = await getApi(`api/recruitment/application/${applicationId}/interviews?allData=true`)
        const interviews = result?.data?.data || []

        const scheduledRounds = interviews
          .filter((interview) => interview?._id !== id)
          .map((interview) => interview?.round)
          .filter(Boolean)

        setScheduledRoundsByApplication((previousState) => ({
          ...previousState,
          [applicationId]: scheduledRounds,
        }))

        return scheduledRounds
      } catch (e) {
        toast.error("Failed to load scheduled interview rounds")
        console.error("Error fetching scheduled rounds:", e)
        return []
      } finally {
        setIsRoundOptionsLoading(false)
      }
    },
    [id],
  )

  useEffect(() => {
    if (!isEmployee) {
      fetchApplications()
    }
  }, [])

  
  useEffect(() => {
    if (id) {
      const fetchInterviewData = async () => {
        try {
          const result = await getApi(API_PATHS.RECRUITMENT_INDIVIDUAL_INTERVIEW, id)
          console.log("Fetched interview data:", result?.data)
          const interview = result?.data?.interview;
          const applicationDeleted = result?.data?.applicationDeleted;
          const candidateDeleted = result?.data?.candidateDeleted;
          
          setInterviewData(interview)
          
          
          if (applicationDeleted) {
            toast.warning("The application for this interview has been deleted. Some information may be unavailable.", {
              position: "top-right",
              autoClose: 5000,
            });
          } else if (candidateDeleted) {
            toast.warning("The candidate for this interview has been deleted. Some information may be unavailable.", {
              position: "top-right",
              autoClose: 5000,
            });
          }
          
          if (isEmployee && interview?.application) {
            setApplicationData([interview.application]);
          }
        } catch (e) {
          toast.error(constant.somethingWrong)
        }
      }

      fetchInterviewData()
    }
  }, [id, isEmployee])

  useEffect(() => {
    const selectedApplicationId = interviewData?.application?._id || interviewData?.application

    if (!selectedApplicationId) {
      return
    }

    fetchScheduledRoundsForApplication(selectedApplicationId)
  }, [fetchScheduledRoundsForApplication, interviewData])

  const [panelData, setPanalData] = useState([])

  const fetchPanels = async () => {
    setIsLoading(true);

    try {
      const result = await getApi(`api/recruitment/panel/?allData=true`);

      const panelData = result?.data?.data || [];

      setPanalData(panelData);

    } catch (e) {
      toast.error(recruitConstant.errorMsg);
      console.error("Error fetching panels:", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPanels();
  }, []);

  useEffect(() => {
    dispatch(getDepartments())
    dispatch(fetchUserData())
  }, [dispatch])

  const { currentInterview, createLoading, updateLoading, loading } = useSelector((state) => state.interview)

  const pad2 = (n) => String(n).padStart(2, "0")
  const formatDateYMD = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
  const combineDateAndTime = (datePart, timePart) => {
    if (!datePart || !timePart) return timePart || datePart || null
    const combined = new Date(datePart)
    combined.setHours(timePart.getHours(), timePart.getMinutes(), timePart.getSeconds(), timePart.getMilliseconds())
    return combined
  }

  
  const transformInterviewDataForAPI = (formValues) => {
    const safeInterviewDate = formValues.interviewDate ? new Date(formValues.interviewDate) : null
    const safeStartTime = formValues.startTime ? new Date(formValues.startTime) : null
    const safeEndTime = formValues.endTime ? new Date(formValues.endTime) : null

    const startOnDate =
      safeInterviewDate && safeStartTime ? combineDateAndTime(safeInterviewDate, safeStartTime) : safeStartTime

    const endOnDate =
      safeInterviewDate && safeEndTime ? combineDateAndTime(safeInterviewDate, safeEndTime) : safeEndTime

    return {
      application: formValues.application,
      interviewers: formValues.interviewers, // Note: mapping interviewer to interviewers
      round: formValues.round,
      interviewStatus: formValues.interviewStatus,
      interviewerFeedback: formValues.interviewerFeedback || "",
      interviewMode: formValues.interviewMode,
      department: formValues.department,
      interviewDate: safeInterviewDate ? formatDateYMD(safeInterviewDate) : "",
      startTime: startOnDate ? startOnDate.toISOString() : "",
      endTime: endOnDate ? endOnDate.toISOString() : "",
      commentForInterviewer: formValues.commentForInterviewer || "",
      reason: formValues.reason || "",
    }
  }

  // Fixed transformation function to properly map API data to form fields
  const transformInterviewDataFromAPI = (apiData) => {
    if (!apiData) return INTERVIEW_INITIAL_VALUES

    return {
      // Application ID from the API data
      application: apiData.application?._id || apiData.application || "",

      candidate: apiData.application?.candidateDetails?.name || apiData.candidateName || "",
      candidateEmail: apiData.application?.candidateDetails?.email || "",
      candidatePhoneNo: apiData.application?.candidateDetails?.phone || "",

      jobTitle: apiData.application?.job?.postingTitle || apiData.jobTitle || "",

      // Department from the interview data
      department: apiData.department?._id || apiData.department || "",

      // Interview specific fields
      interviewers: Array.isArray(apiData.interviewers)
        ? apiData.interviewers.map(interviewer =>
          typeof interviewer === 'object' ? interviewer._id : interviewer
        )
        : [], // This should be an array of IDs
      round: apiData.round || "",
      interviewStatus: apiData.interviewStatus || "",
      interviewerFeedback: apiData.interviewerFeedback || "",
      interviewMode: apiData.interviewMode || "",

      // Date and time fields - convert ISO strings to Date objects
      interviewDate: apiData.interviewDate ? new Date(apiData.interviewDate) : null,
      startTime: apiData.startTime ? new Date(apiData.startTime) : null,
      endTime: apiData.endTime ? new Date(apiData.endTime) : null,

      // Comments
      commentForInterviewer: apiData.commentForInterviewer || "",
      reason: apiData.reason || "",
    }
  }



  const getInitialValues = () => {
    if (id && interviewData) {
      console.log("Using interview data for initial values:", interviewData)
      return transformInterviewDataFromAPI(interviewData)
    }

    // Check if date was passed from calendar
    if (dateFromCalendar) {
      return {
        ...INTERVIEW_INITIAL_VALUES,
        interviewDate: new Date(dateFromCalendar),
      }
    }

    return INTERVIEW_INITIAL_VALUES
  }

  const currentInterviewRound = interviewData?.round || ""

  const getRoundOptionsForApplication = useCallback(
    (applicationId) => {
      const scheduledRounds = scheduledRoundsByApplication[applicationId] || []

      return interviewRoundOptions.map((option) => {
        const isCurrentInterviewRound =
          id &&
          applicationId &&
          normalizeRoundValue(currentInterviewRound) === normalizeRoundValue(option.value)

        const isAlreadyScheduled =
          scheduledRounds.some((round) => normalizeRoundValue(round) === normalizeRoundValue(option.value)) &&
          !isCurrentInterviewRound

        return {
          ...option,
          disabled: Boolean(option.disabled || isAlreadyScheduled),
        }
      })
    },
    [currentInterviewRound, id, normalizeRoundValue, scheduledRoundsByApplication],
  )

  return (
    <>
      <Box >
        <ActionNavbar isCreatePage={true} />
        <Stack>
          {
            id ?
              <>
                <Tabs index={activeMainTab} onChange={handleMainTabChange}>
{ !isEmployee && <TabList className="noRadiusTabs">
                    <Tab>
                      Overview
                    </Tab>
                    <Tab>
                      Additional Info
                    </Tab>
                  </TabList>}

                  <TabPanels mt={2}>
                    <TabPanel>
                      <OverviewPanel
                        navigate={navigate}
                        isOverviewMode={isOverviewMode}
                        id={id}
                        applicationData={applicationData}
                        departments={departments}
                        permission={permission}
                        colors={colors}
                        activeTabIndex={activeTabIndex}
                        getTabStates={getTabStates}
                        handleTabChange={handleTabChange}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        dispatch={dispatch}
                        setSelectedJob={setSelectedJob}
                        getInitialValues={getInitialValues}
                        transformInterviewDataForAPI={transformInterviewDataForAPI}
                        fetchApplicationById={fetchApplicationById}
                        panelData={panelData}
                        combineDateAndTime={combineDateAndTime}
                        createLoading={createLoading}
                        updateLoading={updateLoading}
                        isEmployee={isEmployee}
                        getRoundOptionsForApplication={getRoundOptionsForApplication}
                        fetchScheduledRoundsForApplication={fetchScheduledRoundsForApplication}
                        normalizeRoundValue={normalizeRoundValue}
                        currentInterviewRound={currentInterviewRound}
                        isRoundOptionsLoading={isRoundOptionsLoading}
                      />
                    </TabPanel>

                    <TabPanel display={'flex'} flexDirection={'column'} gap={6}>
                      <Box className="createJobOpening-breadCrumb">
                        <ArrowBackIcon onClick={() => navigate("/recruitment/interviews")} fontSize="20px" cursor={"pointer"} />
                        <Text className="createJobOpening-pageTitle">
                          {/* {isOverviewMode ? "Overview" : id ? constant.editJobOpening : constant.createJobOpening} */}
                          {constant.additionalInfo}
                        </Text>
                      </Box>
                      <Box>
                        <Box width={'100%'} padding={4} borderBottom={"1px"} borderColor={'#e9ebec'} borderTopRadius={"xl"} backgroundColor={'white'}>
                          <Text fontWeight={700} fontSize={16} >Related Interview</Text>
                        </Box>
                        <Interview
                          customApiEndpoint={id ? `api/recruitment/interviews/${id}/related` : undefined}
                        />
                      </Box>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </>
              :
              <>
                <OverviewPanel
                  navigate={navigate}
                  isOverviewMode={isOverviewMode}
                  id={id}
                  applicationData={applicationData}
                  departments={departments}
                  permission={permission}
                  colors={colors}
                  activeTabIndex={activeTabIndex}
                  getTabStates={getTabStates}
                  handleTabChange={handleTabChange}
                  handleNext={handleNext}
                  handleBack={handleBack}
                  dispatch={dispatch}
                  setSelectedJob={setSelectedJob}
                  getInitialValues={getInitialValues}
                  transformInterviewDataForAPI={transformInterviewDataForAPI}
                  fetchApplicationById={fetchApplicationById}
                  panelData={panelData}
                  combineDateAndTime={combineDateAndTime}
                  createLoading={createLoading}
                  updateLoading={updateLoading}
                  isEmployee={isEmployee}
                  getRoundOptionsForApplication={getRoundOptionsForApplication}
                  fetchScheduledRoundsForApplication={fetchScheduledRoundsForApplication}
                  normalizeRoundValue={normalizeRoundValue}
                  currentInterviewRound={currentInterviewRound}
                  isRoundOptionsLoading={isRoundOptionsLoading}
                />
              </>
          }
        </Stack>
      </Box>
    </>
  )
}

export default CreateInterview
